<div
  class="sp-width__full sp-plain-toolbar sp-row__space sp-padding__left-x2 sp-padding__right-x2">
  <img
    class="sp-logo__m"
    [src]="logo_src" />
</div>
